import {CONFIG_AUTHORIZATION_CONNECT_PARTNER} from "../constant";

const roles = {
  ADMIN: 'ROLE_ADMIN',
  PROVINCE: 'ROLE_PROVINCE',
  DISTRICT: 'ROLE_DISTRICT',
  WARD: 'ROLE_WARD',
  VILLAGE: 'ROLE_VILLAGE',
  ROLE_MANAGEMENT: 'ROLE_MANAGEMENT',
  ROLE_MANAGEMENT_DEVICE: 'ROLE_MANAGEMENT_DEVICE',
};

export default {
  roles: roles,
  authenSuccesUrlRedirect: function (hasAuthor) {
    // if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else if (hasAuthor(roles.CREATE)) {
    //   return '/user-management/managed-users';
    // } else {
    //   return '/user-management/managed-users';
    // }
    return '/dashboard.html'
  },

  authorizationMapper: [
    {
      regex: /^\/dashboard.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.ROLE_MANAGEMENT) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD) || hasAuthor(roles.VILLAGE) || hasAuthor(roles.ROLE_MANAGEMENT_DEVICE);
      }
    },
    {
      regex: /^\/devices-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.ROLE_MANAGEMENT) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD) || hasAuthor(roles.VILLAGE) || hasAuthor(roles.ROLE_MANAGEMENT_DEVICE);
      }
    },
    {
      regex: /^\/media-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.ROLE_MANAGEMENT) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD) || hasAuthor(roles.VILLAGE);
      }
    },
    {
      regex: /^\/radio-activities*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.ROLE_MANAGEMENT) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD) || hasAuthor(roles.VILLAGE);
      }
    },
    {
      regex: /^\/history-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.ROLE_MANAGEMENT) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD) || hasAuthor(roles.VILLAGE);
      }
    },
    {
      regex: /^\/report-management*/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.ROLE_MANAGEMENT) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
      }
    },
    // {
    //   regex: /^\/administrator\/user-activity-log.html/,
    //   isAuthorized: function (hasAuthor) {
    //     return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.DISTRICT) || hasAuthor(roles.WARD);
    //   }
    // },
    {
      regex: /^\/administrator\/file-type.html/,
      isAuthorized: function (hasAuthor) {
        // return hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE);
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/key-authentication.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/cache.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/channel-digital.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGEMENT);
      }
    },
    {
      regex: /^\/user-management\/managed-users.html/,
      isAuthorized: function (hasAuthor) {
        return (hasAuthor(roles.ADMIN) || hasAuthor(roles.PROVINCE) || hasAuthor(roles.ROLE_MANAGEMENT)) && !CONFIG_AUTHORIZATION_CONNECT_PARTNER;
      }
    },
    {
      regex: /^\/administrator\/sim.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.ROLE_MANAGEMENT);
      }
    },
    {
      regex: /^\/administrator\/thread.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/sound-speaker.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/radio-activities\/livestream.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN) || hasAuthor(roles.WARD) || hasAuthor(roles.VILLAGE);
      }
    },
    {
      regex: /^\/administrator\/config-authentication.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/version-fw.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/user-activity-log.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/config-sync-htttn.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/config-location.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/queue.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/config-supplier.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/config-text-to-speech.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/administrator\/log-sync-htttn.html/,
      isAuthorized: function (hasAuthor) {
        return hasAuthor(roles.ADMIN);
      }
    },
    {
      regex: /^\/user-management\/managed-users.html/,
      isAuthorized: function () {
        return !CONFIG_AUTHORIZATION_CONNECT_PARTNER;
      }
    },
    {
      regex: /^\/user\/reset-password.html/,
      isAuthorized: function () {
        return !CONFIG_AUTHORIZATION_CONNECT_PARTNER;
      }
    }
  ]
}
